import {Component, computed, inject, signal} from '@angular/core';
import {OrderHistoryService} from '../../core/services/order-history.service';
import {ActivatedRoute, Router} from '@angular/router';
import {VismaOrderListV2Pagination} from '../../core/interfaces/generated/graphql';
import {MatButton} from '@angular/material/button';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {CardComponent} from '../../components/card/card.component';
import {OrderLineItemTableComponent} from '../../components/order-line-item-table/order-line-item-table.component';
import {OrderTableComponent} from '../../components/order-table/order-table.component';
import {NgOptimizedImage} from '@angular/common';
import {LoadingIconComponent} from '../../components/loading-icon/loading-icon.component';
import {BasicModalService} from '../../core/services/basic-modal.service';
import {CustomerService} from '../../core/services/customer.service';
import {DragScrollDirective} from '../../core/directives/drag-scroll.directive';


@Component({
  selector: 'app-order-history-page',
  imports: [
    MatButton,
    MatRadioGroup,
    MatRadioButton,
    CardComponent,
    OrderLineItemTableComponent,
    OrderTableComponent,
    NgOptimizedImage,
    LoadingIconComponent,
    OrderTableComponent,
    DragScrollDirective,
  ],
  templateUrl: './order-history-page.component.html',
  styleUrl: './order-history-page.component.scss'
})
export class OrderHistoryPageComponent {

  private orderHistoryService = inject(OrderHistoryService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private basicModalService = inject(BasicModalService);
  private customerService = inject(CustomerService);

  orderHistory = signal<VismaOrderListV2Pagination|null|undefined>(null);
  viewType = signal('lineItems');
  loadingOrders = signal(false);
  pageIndex = signal(0);

  customerName = computed(() => {
    return this.customerService.selectedCustomer().customer?.fullName;
  })

  lineItems = computed(() => {
    return this.orderHistory()?.items.flatMap(order => this.orderHistoryService.formatOrderToLineItems(order));
  });

  constructor() {
    this.getOrderHistory();
  }

  async getOrderHistory(pageIndex = 0) {
    const vismaId = this.activatedRoute.snapshot.params['vismaId'];
    this.loadingOrders.set(true);
    try {
      this.orderHistory.set(await this.orderHistoryService.getOrdersByVismaCustomerId(vismaId, pageIndex));
    } catch (e) {
      console.error(e);
      this.basicModalService.showErrorModal('Der skete en fejl under hentning af ordrehistorikken');
    }
    this.loadingOrders.set(false);
  }

  goBackToCustomerDataPage() {
    this.router.navigate(['/']);
  }

  changeViewType(viewType: string) {
    this.viewType.set(viewType);
  }

  changePage(pageIndex: number) {
    this.pageIndex.set(pageIndex);
    this.getOrderHistory(pageIndex);
  }

}
